/**
 * A marker to create on the Premiere timeline, mapped from an Air discussion annotation
 * @public
 */
export type PremiereMarker = {
  /** Display name — typically the discussion author + summary */
  name: string;
  /** Full discussion thread text */
  comments: string;
  /** Start time in seconds (from Air annotation timecode) */
  startTimeSeconds: number;
  /** Duration in seconds (annotation range), or 0 for point markers */
  durationSeconds: number;
  /** Premiere marker type */
  markerType: 'comment';
};

/**
 * A chapter to create as a range marker on the Premiere timeline, mapped from Air video chapters
 * @public
 */
export type PremiereChapter = {
  /** Chapter title */
  title: string;
  /** Start time in seconds */
  startTime: number;
  /** End time in seconds */
  endTime: number;
  /** Chapter summary text */
  summary: string;
};

/**
 * Plugin name used for auth and analytics
 * @public
 */
export const PREMIERE_PLUGIN_NAME = 'premiere' as const;
